// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__6Vhyg","title":"style_title__8QQYM","bottom":"style_bottom__cxA6R","button":"style_button__cN7p+"};